//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import './style.scss'
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const thinkOfIdealWeight = useStore((state) => state.thinkOfIdealWeight);
  const setThinkOfIdealWeight = useStore((state) => state.setThinkOfIdealWeight);
  const [next, setNext] = useState(thinkOfIdealWeight.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setThinkOfIdealWeight(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.thinkOfIdealWeight.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={thinkOfIdealWeight} onChange={handleChange}>
          <MultiOption value={'Full of energy each day'}>
            {t('onboarding.thinkOfIdealWeight.options.fullEnergy')}
          </MultiOption>
          <MultiOption value={'More confident'}>
            {t('onboarding.thinkOfIdealWeight.options.confident')}
          </MultiOption>
          <MultiOption value={'More social'}>
            {t('onboarding.thinkOfIdealWeight.options.social')}
          </MultiOption>
          <MultiOption value={'Putting myself first'}>
            {t('onboarding.thinkOfIdealWeight.options.first')}
          </MultiOption>
          <MultiOption value={'Excited about exploring new things'}>
            {t('onboarding.thinkOfIdealWeight.options.excited')}
          </MultiOption>
          <MultiOption value={'Other'}>
            {t('onboarding.thinkOfIdealWeight.options.other')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.thinkOfIdealWeight.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'think-of-ideal-weight',
              answer: thinkOfIdealWeight.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
